import http from '@/utils/httpRequest.js'
import axios from "axios";
const publics = {
    state: {
        navIndex: sessionStorage.getItem('nav_index') || 0, //导航栏下标
        publicityIndex: sessionStorage.getItem('publicity_index') || 0,

        // 区域
        provinceList: JSON.parse(sessionStorage.getItem('provinceList')) || null,


        comName: "",
        itemInfo: null

    },

    mutations: {
        SET_NAVINDEX: (state, navIndex) => {
            state.navIndex = navIndex
        },

        SET_COMNAME: (state, comName) => {
            state.comName = comName
        },
        SET_STEPSTATUS: (state, stepStatus) => {
            state.stepStatus = stepStatus
        },
        SET_provinceList: (state, provinceList) => {
            sessionStorage.setItem('provinceList', JSON.stringify(provinceList))
            state.provinceList = provinceList
        },
        SET_Publicity: (state, publicityIndex) => {
            state.publicityIndex = publicityIndex
        },

    },

    actions: {
        // 机构步骤
        getNavIndex({ commit, state }, data) {
            commit('SET_NAVINDEX', data)
            sessionStorage.setItem('nav_index', data)
        },
        getPublicityIndex({ commit, state }, data) {
            commit('SET_Publicity', data)
            sessionStorage.setItem('publicity_index', data)
        },

            getProvince({ commit, state }, ) {
                return new Promise((resolve, reject) => {
                    axios({
                        url: http.adornUrl('/region/get-region-tree'),
                        method: "get",
                    }).then(res => {
                        var resp = res.data.data
                        commit('SET_provinceList', resp)
                        resolve(res)
                    }).catch(error => {
                        reject(error)
                    })
                })
            },

    }
}

export default publics


// WEBPACK FOOTER //
// ./src/store/modules/public.js